import React, { useState, useEffect } from "react";
// import { CheckCircle } from "lucide-react";
import { useNavigate, useLocation, Link } from "react-router-dom";
//import "../../../features/Checkout/Payment/SuccessPage.css";
import { useDispatch, useSelector } from "react-redux";
// import { UseDispatch } from "react-redux";
import Footer from "../../../components/Footer/Footer";
import SuccessIcon from "../../../assets/icons/Success-Icon.png";
import { fetchAddOns } from "../../../features/products/topPicks/redux/topPicksSlice";

const ReturnExchangeSuccess = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const dispatch = useDispatch();

    const page = state?.page;
    const orderNo = state?.orderNo;
    const { addOns } = useSelector((state) => state.toppick);

    useEffect(() => {
        document.title = "Obsession - Payment Success";
        dispatch(fetchAddOns());
    }, [dispatch]);
    return (
        <>
            <div className="success-container">
                {/*  Success Icon */}
                {/* <CheckCircle className="success-icon" /> */}
                <div className="mb-4">
                    <img src={SuccessIcon} alt="success" />
                </div>

                {/*  Title */}
                <h2 className="success-title">Your {page} is confirmed.</h2>
                <p className="success-subtitle">Our team will be reaching out to you soon to assist further.</p>

                {/*  Estimated Arrival */}
                <div className="arrival-box">
                    <h3 className="arrival-title">Order Details</h3>
                    {/* <p className="arrival-date">--</p>
                    <p className="arrival-id">
                        Order PLACED : <span>{new Date(orderNo?.data?.created_at).toLocaleDateString(
                            "en-GB",
                            {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            }
                        )}</span>
                    </p> */}
                    <p className="arrival-id">
                        Order ID : <span>{orderNo}</span>
                    </p>
                </div>

                {/*  Buttons */}
                <div className="button-group">
                    <Link to={`/OrderTrackingPage/${orderNo}`}>
                        <button
                            className="btn-outline"
                        >
                            TRACK ORDER
                        </button>
                    </Link>&nbsp;
                    <button onClick={() => navigate("/")} className="btn-primary">
                        CONTINUE SHOPPING
                    </button>
                </div>
            </div>
            <section className="top-picks-section">
                <h2 className="top-picks-heading">Perfect Add-ons for Your Order</h2>
                <div className="top-picks-grid">
                    {addOns?.map((item) => (
                        <div key={item.id} className="top-pick-card pointer-crusser">
                            <Link to={`/products${item.action_url}`}>
                                <img
                                    src={item.media}
                                    alt={item.name}
                                    className="top-pick-image"
                                />
                                <p className="top-pick-title" >{item.name}</p>
                            </Link>
                        </div>
                    ))}
                </div>
            </section>
            {/* Fotter section  */}
            <Footer />
        </>
    )
}

export default ReturnExchangeSuccess;